import { Box } from 'components/Box';
import WithdrawHeader from 'components/Header/WithdrawHeader';
import React from 'react'
import WithdrawTabsAll from './WithdrawAllTabs';
import { BgImg, ContainerWidth } from './WithdrawStyled';

const WithdrawDetails: React.FC = () => {

    return (
        <>
            <BgImg style={{ minHeight: '100vh' }}>

                <Box>
                    <WithdrawHeader />

                    <ContainerWidth>
                        <WithdrawTabsAll />
                    </ContainerWidth>

                </Box>
            </BgImg>
        </>
    )
}

export default WithdrawDetails;